/* Hugwarm Ember — theme script (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var TV = window.TV = window.TV || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = TV.moneyFormat || '${{amount}}';
    var v = (Number(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
              .replace(/\{\{\s*amount\s*\}\}/, withCommas)
              .replace(/<[^>]*>/g, '');
  }
  TV.money = money;

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduce || window.Shopify && Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = $('[data-tv-header]');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var drawer = $('[data-tv-drawer]');
    var openBtn = $('[data-tv-drawer-open]');
    if (!drawer || !openBtn) return;
    function setOpen(state) {
      drawer.classList.toggle('is-open', state);
      drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) { var f = $('.tv-drawer__panel button', drawer); if (f) f.focus(); } else { openBtn.focus(); }
    }
    openBtn.addEventListener('click', function () { setOpen(true); });
    $$('[data-tv-drawer-close]', drawer).forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
  }

  /* ---------- announcement rotation (mobile) ---------- */
  function initAnnouncement() {
    var ann = $('[data-tv-ann]');
    if (!ann) return;
    var items = $$('.tv-ann__item', ann);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth >= 990) return;
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3800);
  }

  /* ---------- horizontal rails ---------- */
  function initRails() {
    $$('[data-tv-rail]').forEach(function (rail) {
      var sec = rail.closest('section');
      if (!sec) return;
      var prev = $('[data-tv-rail-prev]', sec), next = $('[data-tv-rail-next]', sec);
      var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 320; };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- heat dial ---------- */
  var LEVELS = [
    { t: '82', l: 'Barely-there glow' },
    { t: '≈ 88', l: 'Soft warmth' },
    { t: '≈ 95', l: 'Cozy' },
    { t: '≈ 102', l: 'Toasty' },
    { t: '≈ 108', l: 'Fireside' },
    { t: '115', l: 'Fresh from the dryer' }
  ];
  function initHeat() {
    $$('[data-tv-heat]').forEach(function (sec) {
      var range = $('[data-tv-heat-range]', sec);
      var num = $('[data-tv-heat-num]', sec), lab = $('[data-tv-heat-label]', sec), temp = $('[data-tv-heat-temp]', sec);
      var ticks = $$('[data-tv-heat-set]', sec);
      var touched = false;
      function set(v) {
        v = Math.max(1, Math.min(6, Number(v)));
        sec.style.setProperty('--lvl', v);
        range.value = v;
        num.textContent = v;
        lab.textContent = LEVELS[v - 1].l;
        temp.textContent = LEVELS[v - 1].t;
        ticks.forEach(function (t) { t.classList.toggle('is-on', Number(t.getAttribute('data-tv-heat-set')) <= v); });
      }
      range.addEventListener('input', function () { touched = true; set(range.value); });
      ticks.forEach(function (t) { t.addEventListener('click', function () { touched = true; set(t.getAttribute('data-tv-heat-set')); }); });
      set(range.value);
      // gentle demo: warm up 1 → 4 when it scrolls into view
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          var v = 1; set(1);
          var iv = setInterval(function () { if (touched) return clearInterval(iv); v++; set(v); if (v >= 4) clearInterval(iv); }, 420);
        }, { threshold: 0.45 });
        io.observe(sec);
      }
    });
  }

  /* ---------- UGC videos ---------- */
  function initVideos() {
    var vids = $$('[data-tv-ugc] .tv-vid');
    if (!vids.length) return;
    function load(fig) {
      var v = $('video', fig);
      if (v && !v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
      return v;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = load(e.target);
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio > 0.55) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: [0, 0.55, 1], rootMargin: '200px 0px' });
      vids.forEach(function (f) { io.observe(f); });
    } else { vids.forEach(load); }
    vids.forEach(function (fig) {
      var btn = $('[data-tv-vid-sound]', fig), v = $('video', fig);
      function toggle() {
        var on = !fig.classList.contains('is-sound');
        vids.forEach(function (o) { o.classList.remove('is-sound'); var ov = $('video', o); if (ov) ov.muted = true; });
        if (on) { load(fig); v.muted = false; fig.classList.add('is-sound'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        if (btn) btn.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      fig.addEventListener('click', toggle);
    });
  }

  /* ---------- product page ---------- */
  function initPDP() {
    var root = $('[data-tv-pdp]');
    if (!root) return;

    /* gallery */
    var track = $('[data-tv-gal-track]', root);
    var slides = $$('.tv-gal__slide', track);
    var dotsWrap = $('[data-tv-gal-dots]', root);
    var count = $('[data-tv-gal-count]', root);
    var dots = slides.map(function (_, i) { var d = document.createElement('i'); if (!i) d.className = 'is-on'; dotsWrap.appendChild(d); return d; });
    var cur = 0, raf = null;
    function setActive(i) {
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    setActive(0);
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; if (track.clientWidth) setActive(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    function showColor(gkey) {
      $$('.tv-gal__slide--color', root).forEach(function (s) {
        $$('.tv-gal__layer', s).forEach(function (l) {
          var on = l.getAttribute('data-gkey') === gkey;
          l.classList.toggle('is-on', on);
          if (on) { var img = $('img', l); if (img) img.loading = 'eager'; }
        });
      });
      var stickyWrap = $('[data-tv-sticky-img]', root), stickyImg = stickyWrap && $('img', stickyWrap);
      var ssrc = stickyWrap && stickyWrap.getAttribute('data-src-' + gkey);
      if (stickyImg && ssrc) { stickyImg.src = ssrc; stickyImg.removeAttribute('srcset'); }
      if (window.innerWidth < 990 && track.scrollLeft > 4) track.scrollTo({ left: 0, behavior: 'smooth' });
    }

    /* offer */
    var tiers = $$('input[name="tv_tier"]', root);
    var units = $$('.tv-unit', root);
    var priceEl = $('[data-tv-price]', root), compareEl = $('[data-tv-compare]', root), saveEl = $('[data-tv-save]', root);
    var atc = $('[data-tv-atc]', root), atcPrice = $('[data-tv-atc-price]', root), atcErr = $('[data-tv-atc-err]', root);
    var stickyBar = $('[data-tv-sticky]', root), stickyMeta = $('[data-tv-sticky-meta]', root), stickyBtn = $('[data-tv-atc-sticky]', root);
    var qty = 1, code = '';
    var tierLabel = { 1: '1 Hugwarm', 2: '2 Hugwarms', 4: '4 Hugwarms (1 free)' };

    function currentTier() { return tiers.filter(function (t) { return t.checked; })[0] || tiers[0]; }
    function applyTier() {
      var t = currentTier(); if (!t) return;
      qty = Number(t.getAttribute('data-qty')) || 1;
      code = t.getAttribute('data-code') || '';
      var p = Number(t.getAttribute('data-price')), c = Number(t.getAttribute('data-compare'));
      if (priceEl) priceEl.textContent = money(p);
      if (compareEl) compareEl.textContent = money(c);
      if (saveEl) saveEl.textContent = c > p ? 'Save ' + Math.floor((c - p) * 100 / c) + '%' : 'Sale';
      if (atcPrice) atcPrice.textContent = money(p);
      var sn = $('[data-tv-shipnote]', root), fsq = Number(root.getAttribute('data-free-ship')) || 2;
      if (sn) sn.textContent = qty >= fsq ? sn.getAttribute('data-free') : sn.getAttribute('data-paid');
      if (stickyMeta) stickyMeta.textContent = (tierLabel[qty] || qty + ' Hugwarms') + ' · ' + money(p);
      units.forEach(function (u) {
        var n = Number(u.getAttribute('data-unit'));
        if (n <= qty) u.removeAttribute('hidden'); else u.setAttribute('hidden', '');
        var nm = $('[data-unit-name]', u);
        if (nm) nm.textContent = qty > 1 ? 'Hugwarm ' + n : 'Color';
      });
    }
    function applyUnit(u) {
      var c = $('input:checked', u); if (!c) return;
      var val = $('[data-unit-val]', u); if (val) val.textContent = c.getAttribute('data-color');
      if (u.getAttribute('data-unit') === '1') showColor(c.getAttribute('data-gkey'));
    }
    tiers.forEach(function (t) { t.addEventListener('change', applyTier); });
    units.forEach(function (u) { $$('input', u).forEach(function (i) { i.addEventListener('change', function () { applyUnit(u); }); }); });

    /* url params: ?tier=2|4 and ?variant=ID */
    try {
      var qs = new URLSearchParams(window.location.search);
      var wantTier = qs.get('tier');
      if (wantTier) tiers.forEach(function (t) { if (t.value === wantTier) t.checked = true; });
      var wantVar = qs.get('variant');
      if (wantVar) units.forEach(function (u) { $$('input', u).forEach(function (i) { if (i.value === wantVar) i.checked = true; }); });
    } catch (e) {}
    if (!currentTier().checked) tiers[0].checked = true;
    units.forEach(applyUnit);
    applyTier();

    function addToCart() {
      var map = {}, order = [];
      units.forEach(function (u) {
        if (Number(u.getAttribute('data-unit')) > qty) return;
        var c = $('input:checked', u); if (!c) return;
        if (map[c.value] === undefined) { map[c.value] = 0; order.push(c.value); }
        map[c.value] += 1;
      });
      var items = order.length ? order.map(function (id) { return { id: Number(id), quantity: map[id] }; })
                               : [{ id: Number(root.getAttribute('data-default-variant')), quantity: qty }];
      atc.classList.add('is-busy'); atc.disabled = true;
      if (atcErr) atcErr.hidden = true;
      fetch((TV.routes && TV.routes.cartAdd) || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        var mode = root.getAttribute('data-after-add') || 'drawer';
        if (mode === 'drawer' && TV.cart && TV.cart.enabled()) {
          atc.classList.remove('is-busy'); atc.disabled = false;
          TV.cart.open();
          return;
        }
        var goCart = mode === 'cart';
        var cartUrl = (TV.routes && TV.routes.cart) || '/cart';
        if (goCart) window.location.href = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl)) : cartUrl;
        else window.location.href = code ? ('/checkout?discount=' + encodeURIComponent(code)) : '/checkout';
      }).catch(function () {
        atc.classList.remove('is-busy'); atc.disabled = false;
        if (atcErr) atcErr.hidden = false;
      });
    }
    if (atc) atc.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);
    window.addEventListener('pageshow', function () { if (atc) { atc.classList.remove('is-busy'); atc.disabled = false; } });

    /* sticky bar: show once the main button has scrolled away */
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      var footer = $('.tv-ftr');
      var atcVisible = true, footVisible = false;
      var sync = function () {
        var on = !atcVisible && !footVisible && atc.getBoundingClientRect().top < 0;
        stickyBar.classList.toggle('is-on', on);
        stickyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (e) { atcVisible = e[0].isIntersecting; sync(); }).observe(atc);
      if (footer) new IntersectionObserver(function (e) { footVisible = e[0].isIntersecting; sync(); }).observe(footer);
      window.addEventListener('scroll', sync, { passive: true });
    }

    /* evergreen countdown (persists per visitor) */
    var timer = $('[data-tv-timer]', root);
    if (timer) {
      var hEl = $('[data-h]', timer), mEl = $('[data-m]', timer), sEl = $('[data-s]', timer);
      var KEY = 'tv_offer_deadline_v1', WIN = (8 * 60 + 17) * 60 * 1000, deadline = 0;
      try { deadline = Number(localStorage.getItem(KEY)); } catch (e) {}
      var reset = function () { deadline = Date.now() + WIN; try { localStorage.setItem(KEY, String(deadline)); } catch (e) {} };
      if (!deadline || isNaN(deadline) || deadline <= Date.now()) reset();
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var left = deadline - Date.now();
        if (left <= 0) { reset(); left = WIN; }
        var s = Math.floor(left / 1000);
        hEl.textContent = pad(Math.floor(s / 3600)); mEl.textContent = pad(Math.floor(s % 3600 / 60)); sEl.textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    }

    /* ships-by date */
    var ship = $('[data-tv-ship]', root);
    if (ship) {
      var d = new Date(); d.setDate(d.getDate() + 1);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      ship.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
  }

  /* ---------- cart drawer + bundle upsells ---------- */
  var Cart = TV.cart = (function () {
    var C = null;
    try { var ce = document.getElementById('tvCartConfig'); C = ce ? JSON.parse(ce.textContent) : null; } catch (e) { C = null; }
    var drawer = null, panel = null, lastFocus = null, cart = null, prevN = null, busy = false, iconCache = {};

    function route(k, d) { return (TV.routes && TV.routes[k]) || d; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function icon(n) {
      if (!(n in iconCache)) {
        var t = document.getElementById('tvCdIcons');
        var el = t && t.content ? t.content.querySelector('[data-i="' + n + '"]') : null;
        iconCache[n] = el ? el.innerHTML : '';
      }
      return iconCache[n];
    }
    function api(url, body) {
      var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
                     : { headers: { 'Accept': 'application/json' } };
      return fetch(url, opt).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Something went wrong');
          return j;
        });
      });
    }
    function getCart() { return api(route('cartJs', '/cart.js')); }
    function isHero(it) { return C && Number(it.product_id) === Number(C.productId); }
    function variant(id) { if (!C) return null; for (var i = 0; i < C.variants.length; i++) if (Number(C.variants[i].id) === Number(id)) return C.variants[i]; return null; }
    function availVariants() { return C ? C.variants.filter(function (v) { return v.available !== false; }) : []; }
    function pct(full, now) { return full > 0 ? Math.floor((full - now) * 100 / full) : 0; }
    function tierDiscount(n) {
      if (!C) return 0;
      if (n >= 4) return Math.max(0, 4 * C.unit - C.p4);
      if (n >= 2) return Math.max(0, 2 * C.unit - C.p2);
      return 0;
    }

    function model(c) {
      var n = 0, lastHeroVar = null, compareTotal = 0;
      (c.items || []).forEach(function (it) {
        if (isHero(it)) { n += it.quantity; lastHeroVar = it.variant_id || it.id; compareTotal += Math.max(C.compare, it.price) * it.quantity; }
        else compareTotal += it.original_line_price;
      });
      var subtotal = c.original_total_price != null ? c.original_total_price : c.total_price;
      var auto = (c.total_discount || 0) > 0;
      var savings = auto ? c.total_discount : tierDiscount(n);
      var total = Math.max(0, subtotal - savings);
      var code = auto ? '' : (n >= 4 ? C.code4 : (n >= 2 ? C.code2 : ''));
      return { n: n, lastHeroVar: lastHeroVar, subtotal: subtotal, savings: savings, total: total, auto: auto, code: code,
               compareTotal: Math.max(compareTotal, total), freeShip: n >= C.freeShipQty, count: c.item_count || 0 };
    }

    /* ---- pieces ---- */
    function progressHTML(m) {
      if (!m.n) return '';
      var fsq = C.freeShipQty, top = Math.max(4, fsq), stops = [];
      stops.push({ q: fsq, label: fsq >= 4 ? 'Free shipping + best price' : 'Free shipping', ic: 'truck' });
      if (fsq < 4) stops.push({ q: 4, label: 'Best price', ic: 'sparkle' });
      var msg;
      if (m.n < fsq) { var k = fsq - m.n; msg = 'Add <b>' + k + ' more Hugwarm' + (k > 1 ? 's' : '') + '</b> to unlock <b>free shipping</b>'; }
      else if (m.n < 4) { var r = 4 - m.n; msg = '<b>Free shipping unlocked.</b> ' + r + ' more for our best price — ' + TV.money(Math.round(C.p4 / 4)) + ' each'; }
      else msg = '<b>Free shipping + best price unlocked.</b> Nicely done.';
      var from = prevN == null ? m.n : prevN;
      var p0 = Math.min(from, top) / top * 100, p1 = Math.min(m.n, top) / top * 100;
      var html = '<div class="tv-cdp' + (m.n >= fsq ? ' is-free' : '') + '">' +
        '<p class="tv-cdp__msg" aria-live="polite">' + icon(m.n >= fsq ? 'check' : 'truck') + '<span>' + msg + '</span></p>' +
        '<div class="tv-cdp__track"><span class="tv-cdp__fill" style="--p:' + p0 + '%" data-p="' + p1 + '%"></span>';
      stops.forEach(function (s) {
        var on = m.n >= s.q, fresh = on && from < s.q;
        html += '<span class="tv-cdp__stop' + (on ? ' is-on' : '') + (fresh ? ' is-pop' : '') + '" style="--x:' + (s.q / top * 100) + '%">' +
                '<i>' + icon(on ? 'check' : s.ic) + '</i><em>' + esc(s.label) + '</em></span>';
      });
      return html + '</div></div>';
    }

    function linesHTML(c) {
      return '<ul class="tv-cdl">' + c.items.map(function (it) {
        var hero = isHero(it), v = hero ? variant(it.variant_id || it.id) : null;
        var img = v ? v.img : (it.image || '');
        var cmp = hero ? Math.max(C.compare, it.price) * it.quantity : it.original_line_price;
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return '<li class="tv-cdl__it" data-key="' + esc(it.key) + '">' +
          '<a class="tv-cdl__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="120" height="150" loading="lazy">' : '') + '</a>' +
          '<div class="tv-cdl__info">' +
            '<a class="tv-cdl__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (vt ? '<span class="tv-cdl__v">' + (v ? '<i style="--c:' + esc(v.hex) + '"></i>' : '') + esc(vt) + '</span>' : '') +
            '<div class="tv-cdl__row">' +
              '<div class="tv-cdq">' +
                '<button type="button" aria-label="Remove one" data-tv-cd-qty="' + esc(it.key) + '|' + (it.quantity - 1) + '">' + icon('minus') + '</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" aria-label="Add one" data-tv-cd-qty="' + esc(it.key) + '|' + (it.quantity + 1) + '">' + icon('plus') + '</button>' +
              '</div>' +
              '<button type="button" class="tv-cdl__rm" data-tv-cd-qty="' + esc(it.key) + '|0">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="tv-cdl__p">' + (cmp > it.final_line_price ? '<s>' + TV.money(cmp) + '</s>' : '') + '<strong>' + TV.money(it.original_line_price) + '</strong></div>' +
        '</li>';
      }).join('') + '</ul>';
    }

    function swatchRow(slot, label, preferId) {
      var vs = availVariants(); if (!vs.length) return '';
      var pick = variant(preferId) && variant(preferId).available !== false ? Number(preferId) : Number(vs[0].id);
      return '<fieldset class="tv-cdu__row"><legend>' + esc(label) + ' <em data-tv-cdu-name>' + esc((variant(pick) || vs[0]).color) + '</em></legend><div class="tv-cdu__sw">' +
        vs.map(function (v) {
          return '<label title="' + esc(v.color) + '"><input type="radio" name="tvcdu_' + slot + '" value="' + v.id + '" data-img="' + esc(v.img) + '" data-color="' + esc(v.color) + '"' + (Number(v.id) === pick ? ' checked' : '') + '>' +
                 '<span style="--c:' + esc(v.hex) + '"></span></label>';
        }).join('') + '</div></fieldset>';
    }

    function upsellHTML(m) {
      if (!C.upsell || m.n < 1 || m.n >= 4) return '';
      var need, add, kicker, title, sub, perks = [], alt = '';
      var each4 = TV.money(Math.round(C.p4 / 4));
      if (m.n === 1) {
        need = 1; add = C.p2 - C.unit; kicker = 'Most popular upgrade'; title = 'Make it a <em>pair.</em>';
        sub = 'Add a second Hugwarm for just <b>' + TV.money(add) + '</b>' + (C.freeShipQty <= 2 ? ' — and shipping is on us.' : '.');
        if (C.freeShipQty <= 2) perks.push(['truck', 'Free shipping']);
        perks.push(['sparkle', 'Save ' + pct(2 * C.compare, C.p2) + '%']);
        perks.push(['heart', TV.money(Math.round(C.p2 / 2)) + ' each']);
        alt = '<button type="button" class="tv-cdu__alt" data-tv-cd-jump="3">Or go for 4 — ' + each4 + ' each ' + icon('arrow') + '</button>';
      } else if (m.n === 2) {
        need = 2; add = C.p4 - C.p2; kicker = 'Best value'; title = 'Make it <em>four.</em>';
        sub = 'Two more for <b>' + TV.money(add) + '</b> and every Hugwarm drops to <b>' + each4 + '</b> — our lowest price.';
        perks.push(['sparkle', 'Save ' + pct(4 * C.compare, C.p4) + '%']);
        perks.push(['heart', each4 + ' each']);
        perks.push(['gift', 'Gift-ready']);
      } else {
        need = 1; add = C.p4 - (C.p2 + C.unit); kicker = 'So close'; title = 'Your 4th for just <em>' + TV.money(add) + '.</em>';
        sub = 'One more completes the 4-pack and drops every Hugwarm to <b>' + each4 + '</b>.';
        perks.push(['sparkle', 'Lowest price']);
        perks.push(['heart', each4 + ' each']);
      }
      if (add <= 0) return '';
      var prefer = m.lastHeroVar, rows = '';
      for (var i = 1; i <= need; i++) rows += swatchRow(i, need > 1 ? 'Hugwarm ' + (m.n + i) : 'Color', prefer);
      var pv = variant(prefer) || availVariants()[0] || {};
      return '<section class="tv-cdu" data-tv-cdu data-need="' + need + '">' +
        '<div class="tv-cdu__media"><img src="' + esc(pv.img || '') + '" alt="" width="180" height="225" loading="lazy" data-tv-cdu-img>' +
          (need > 1 ? '<span class="tv-cdu__x2">×2</span>' : '') + '</div>' +
        '<div class="tv-cdu__main">' +
          '<p class="tv-cdu__k">' + icon('sparkle') + esc(kicker) + '</p>' +
          '<h3 class="tv-cdu__t">' + title + '</h3>' +
          '<p class="tv-cdu__s">' + sub + '</p>' +
          '<ul class="tv-cdu__perks">' + perks.map(function (p) { return '<li>' + icon(p[0]) + esc(p[1]) + '</li>'; }).join('') + '</ul>' +
        '</div>' +
        '<div class="tv-cdu__pick">' + rows + '</div>' +
        '<button type="button" class="tv-btn tv-cdu__add" data-tv-cd-add>' + icon('plus') + '<span>Add ' + (need > 1 ? 'both' : 'it') + '</span><span class="tv-btn__sep" aria-hidden="true"></span><span>+' + TV.money(add) + '</span></button>' +
        alt +
      '</section>';
    }

    function giftsHTML(m) {
      if (!C.gifts || !m.n) return '';
      return '<div class="tv-cdg">' +
        '<div class="tv-cdg__imgs"><img src="' + esc(C.giftImgs[0]) + '" alt="" width="44" height="44"><img src="' + esc(C.giftImgs[1]) + '" alt="" width="44" height="44"></div>' +
        '<p><b>2 free gifts included</b><span>Travel &amp; Storage Bag + Warm Home Digital Bundle</span></p>' +
        '<span class="tv-cdg__v"><s>' + esc(C.giftValue) + '</s>Free</span></div>';
    }

    function emptyHTML() {
      return '<div class="tv-cde"><div class="tv-cde__img"><img src="' + esc(C.emptyImg) + '" alt="" width="240" height="300"></div>' +
        '<h3>Your bag is <em>cold.</em></h3><p>One Hugwarm fixes that — six levels of warm, from shoulders to toes.</p>' +
        '<a class="tv-btn" href="' + esc(C.url) + '">Shop the Hugwarm ' + icon('arrow') + '</a></div>';
    }

    function footHTML(m) {
      if (!m.count) return '';
      var href = C.checkout + (m.code ? '?discount=' + encodeURIComponent(m.code) : '');
      var youSave = m.compareTotal - m.total;
      return '<div class="tv-cdf">' +
        '<div class="tv-cdf__row"><span>Subtotal</span><span>' + TV.money(m.subtotal) + '</span></div>' +
        (m.savings > 0 ? '<div class="tv-cdf__row tv-cdf__row--save"><span>' + icon('sparkle') + 'Bundle savings' + (m.auto ? '' : ' <small>applied at checkout</small>') + '</span><span>−' + TV.money(m.savings) + '</span></div>' : '') +
        '<div class="tv-cdf__row"><span>Shipping</span><span>' + (m.freeShip ? '<b class="tv-cdf__free">Free</b>' : esc(C.shipNote)) + '</span></div>' +
        '<div class="tv-cdf__tot"><span>Total</span><span>' + (youSave > 0 ? '<s>' + TV.money(m.compareTotal) + '</s>' : '') + '<strong>' + TV.money(m.total) + '</strong></span></div>' +
        (youSave > 0 ? '<p class="tv-cdf__saved">' + icon('heart') + 'You’re saving ' + TV.money(youSave) + ' today</p>' : '') +
        '<a class="tv-btn tv-btn--xl tv-cdf__go" href="' + esc(href) + '">' + icon('lock') + '<span>Checkout</span><span class="tv-btn__sep" aria-hidden="true"></span><span>' + TV.money(m.total) + '</span></a>' +
        '<p class="tv-cdf__trust"><span>' + icon('shield') + '30-night trial</span><span>' + icon('truck') + (m.freeShip ? 'Free shipping' : 'Ships in 24h') + '</span><span>' + icon('lock') + 'Secure checkout</span></p>' +
      '</div>';
    }

    function paint(c) {
      cart = c;
      var m = model(c);
      var body = m.count ? progressHTML(m) + linesHTML(c) + upsellHTML(m) + giftsHTML(m) : emptyHTML();
      var foot = footHTML(m);
      $$('[data-tv-cart-body]').forEach(function (el) { el.innerHTML = body; });
      $$('[data-tv-cart-foot]').forEach(function (el) { el.innerHTML = foot; el.hidden = !foot; });
      $$('[data-tv-cart-count]').forEach(function (el) { el.textContent = m.count; if (m.count) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
      $$('[data-tv-cart-h]').forEach(function (el) { el.innerHTML = m.count ? 'Almost <em>warm.</em>' : 'Your bag is <em>empty.</em>'; });
      $$('[data-tv-cart-count-label]').forEach(function (el) { el.textContent = m.count ? '(' + m.count + ')' : ''; });
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        $$('.tv-cdp__fill').forEach(function (f) { f.style.setProperty('--p', f.getAttribute('data-p')); });
      }); });
      prevN = m.n;
      return m;
    }
    function refresh() { return getCart().then(paint).catch(function () {}); }

    function setBusy(on, el) {
      busy = on;
      $$('[data-tv-cart-body], [data-tv-cart-foot]').forEach(function (b) { b.classList.toggle('is-busy', on); });
      if (el) el.classList.toggle('is-busy', on);
    }
    function toast(msg) {
      var t = document.getElementById('tvToast'); if (!t) return;
      t.textContent = msg; t.hidden = false; t.classList.add('is-on');
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); t.hidden = true; }, 3200);
    }
    function change(key, q, el) {
      if (busy) return; setBusy(true, el);
      api(route('cartChange', '/cart/change.js'), { id: key, quantity: Math.max(0, q) })
        .then(paint).catch(function (e) { toast(e.message); }).then(function () { setBusy(false, el); });
    }
    function addItems(items, el) {
      if (busy) return Promise.resolve(); setBusy(true, el);
      return api(route('cartAdd', '/cart/add.js'), { items: items }).then(getCart).then(paint)
        .catch(function (e) { toast(e.message); }).then(function () { setBusy(false, el); });
    }

    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tv-locked');
      setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
      return refresh();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tv-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function init() {
      if (!C) return;
      drawer = $('[data-tv-cd]'); panel = drawer ? $('.tv-cd__panel', drawer) : null;
      var useDrawer = drawer && C.drawer !== false;
      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target : null; if (!t) return;
        var opener = t.closest('[data-tv-cart-open]');
        if (opener && useDrawer && !document.querySelector('[data-tv-cart-page]')) { e.preventDefault(); open(); return; }
        if (t.closest('[data-tv-cd-close]')) { close(); return; }
        var q = t.closest('[data-tv-cd-qty]');
        if (q) { var pr = q.getAttribute('data-tv-cd-qty').split('|'); change(pr[0], Number(pr[1]), q.closest('.tv-cdl__it')); return; }
        var addBtn = t.closest('[data-tv-cd-add]');
        if (addBtn) {
          var card = addBtn.closest('[data-tv-cdu]'), map = {}, order = [];
          $$('input[type=radio]:checked', card).forEach(function (r) { if (map[r.value] === undefined) { map[r.value] = 0; order.push(r.value); } map[r.value]++; });
          var items = order.map(function (id) { return { id: Number(id), quantity: map[id] }; });
          if (items.length) addItems(items, card);
          return;
        }
        var jump = t.closest('[data-tv-cd-jump]');
        if (jump) {
          var card2 = jump.closest('[data-tv-cdu]'), r0 = card2 && $('input[type=radio]:checked', card2);
          var vid = r0 ? Number(r0.value) : (cart && model(cart).lastHeroVar);
          if (vid) addItems([{ id: vid, quantity: Number(jump.getAttribute('data-tv-cd-jump')) || 3 }], card2);
        }
      });
      document.addEventListener('change', function (e) {
        var r = e.target; if (!r || !r.matches || !r.matches('[data-tv-cdu] input[type=radio]')) return;
        var row = r.closest('.tv-cdu__row'), nm = row && $('[data-tv-cdu-name]', row);
        if (nm) nm.textContent = r.getAttribute('data-color');
        var card = r.closest('[data-tv-cdu]'), img = card && $('[data-tv-cdu-img]', card);
        if (img && r.getAttribute('data-img')) img.src = r.getAttribute('data-img');
      });
      document.addEventListener('keydown', function (e) {
        if (!drawer || !drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          var f = $$('a[href], button:not([disabled]), input:not([disabled])', panel).filter(function (x) { return x.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
      if (document.querySelector('[data-tv-cart-page]')) refresh();
      window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    }

    return { init: init, open: open, close: close, refresh: refresh, enabled: function () { return !!(C && drawer && C.drawer !== false); } };
  })();

  /* ---------- reviews: read more (mobile) ---------- */
  function initReviews() {
    $$('[data-tv-revmore]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('section'), wall = sec && $('[data-tv-revwall]', sec);
        if (wall) wall.classList.add('is-all');
      });
    });
  }

  /* ---------- cart page qty (no-JS fallback form) ---------- */
  function initCart() {
    $$('[data-tv-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var parts = b.getAttribute('data-tv-qty').split('|');
        b.disabled = true;
        fetch((TV.routes && TV.routes.cartChange) || '/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parts[0], quantity: Math.max(0, Number(parts[1])) })
        }).then(function () { window.location.reload(); }).catch(function () { b.disabled = false; });
      });
    });
  }

  function boot() {
    initReveal();
    initHeader();
    initAnnouncement();
    initRails();
    initHeat();
    initVideos();
    initPDP();
    initCart();
    initReviews();
    Cart.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initHeat(); initRails(); });
})();
